<tt-page class="col-xs-12 col-md-6 sp-0" *ngIf="!!setting">
    <tt-card>
        <form class="form-horizontal sp-0" name="formTextileStockSearch" novalidate (ngSubmit)="searchItems()" method="get" role="form">
            <tt-input ttRememberId="textilestocksearch.searchtext" ttLabel="searchtext" ttFocus="true" [(ttModel)]="setting.searchtext" (ttModelChange)="onChanged($event, 'searchtext')" ttShowClearButton [ttButtons]="searchTextButtons"></tt-input>
        </form>
    </tt-card>

    <tt-list [ttData]="itemsListTextileStocks"></tt-list>
</tt-page>
